import "../../assets/css/AddCatalogs.css";
import React, { useEffect, useMemo, useState } from "react";
import BackgroundComponent from "../../components/Layout/BackgroundProfile/BackgroundProfile";
import ManageFirmPracticeHeadsBackground from "../../assets/images&icons/bg-manageFirmPracticeHeads.png";
import PaginatedTable from "../../components/Organismos/Table/PaginatedTable";
import CatalogTableC from "../../components/Catalogs/CatalogTableC";
import { Link } from "react-router-dom";
import { transformData } from "../../hooks/Table/TransformColumnsForExport";
import useDataLoader2 from "../../hooks/useDataLoader2";
import Icon from "../../components/Atomos/Icons/Icon";
import CatalogTitle from "../../components/Moleculas/Catalog Text/CatalogTitle";
import { useSelector } from "react-redux";
import { Appstore } from "../../redux";
import { defaultPageSize } from '../../utils/const';
import Axios from "../../utils/axios";

const WSGDots = require("../../assets/images&icons/WSGDots.svg");

const ManageFirmPracticeHeadsTab: React.FC = () => {
  const manageFirm = useSelector((state: Appstore) => state.manageFirm);
  const [aopFiltered, setAopFiltered] = useState<any[]>([]);
  const [exportData, setExportData] = useState<any[]>([]);
  const [persons, setPersons] = useState<any[]>([]);

  const fields = [
    'id',
    'legacyId',
    'name',
    'practiceHead',
    '_ts'
  ]
  const { 
    data, 
    totalCount, 
    sort, 
    setSort, 
    pagination, 
    setPagination 
  } = useDataLoader2<any>({
    endpoint: `/areaOfPractice?filter={"firms":{"value":["${manageFirm.selectedFirm?.id}"]}}&`,
    defaultPageSize,
    fields
  });

  const filteredData = () => {
    if (data && data.length > 0 && manageFirm.selectedFirm) {
			const filtered = data
			.map(aop => ({
				...aop,
				firmPracticeHeads: aop.practiceHead
					?.map((personId: any) => ({
						id: personId,
						person: persons.find((person) => personId == person.id)
					}))
					.filter((fph: any) => fph.person)
			}))
      setAopFiltered(filtered);
    }
  };

  useEffect(() => {
		if(!manageFirm.selectedFirm) {
		  return;
		}
		const axios = new Axios();
		axios.Get(`/person?filter={"firm":{"value":["${manageFirm.selectedFirm.id}"],"comparisonType":"EQUAL"}}&fields=["id","name", "lastName"]`)
			.then((res) => {
				setPersons(res.data);
				if (data && data.length > 0) {
					filteredData();
				}
			})
			.catch((err) => {
				console.error(err);
			});
  }, [manageFirm.selectedFirm, data]);

  const columnsDef = useMemo(() => [
    { 
      id: "count", 
      header: "#", 
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p>
          {rowIndex + 1 + pagination.pageIndex * pagination.pageSize}
        </p>
      )
    },
    { id: "name", header: "AOP" },
    { 
      id: "practiceHead", 
      header: "Practice Head",
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <p>
          {row?.firmPracticeHeads?.length > 0
            ? row?.firmPracticeHeads.map(
                (fph: any) => fph.person.name + " " + fph.person.lastName
              )
              .join(", ")
            : "-Not Assigned-"}
        </p>
      )
    },
    {
      id: "edit",
      header: "Edit",
      enableSorting: false,
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <Link
          className="edit"
          to={`Edit/${row.id}`}
          state={{ ...row, firmId: manageFirm.selectedFirm?.id }}
        >
          {row.firmPracticeHeads &&
          row.firmPracticeHeads.length > 0
            ? "Edit"
            : "Assign"}
          <div className="editsvg">
            <Icon />
          </div>
        </Link>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize, manageFirm.selectedFirm?.id]);

  const memoizedData = useMemo(() => aopFiltered, [aopFiltered]);

  useEffect(() => {
    const newData = (memoizedData || []).map((data: any) => {
      return {
        ...data,
        PracticeHead:
          data["firmPracticeHeads"]?.length > 0 ? "Assigned" : "Not Assigned",
        AOP: data["name"],
      };
    });
    setExportData(newData);
  }, [memoizedData]);

  return (
    <>
        <div className="flex flex-col pt-7 gap-5 md:gap-6 lg:gap-7 md:pt-8 lg:pt-10 pb-5">
          <div className="flex lg:min-h-[70px] gap-4 justify-between">
            <CatalogTitle
              title={`Practice Heads`}
              className="text-white !p-0 lg:text-[52px] md:text-[44px] text-[42px]"
            />
            <div
              className="md:min-w-[20rem] min-h[4.5rem] overflow-hidden flex-1 hidden relative md:flex"
              style={{
                backgroundImage: `url(${WSGDots.default})`,
              }}
            ></div>
          </div>
          <hr className="flex h-0 justify-end items-center self-stretch relative z-10" />
        </div>

        <CatalogTableC
          catalogName={"Practice Head"}
          route={"PracticeHead"}
          totalCount={memoizedData?.length ?? 0}
          noNewCatalog
        >
          <PaginatedTable
            data={aopFiltered || []}
            columnsDef={columnsDef}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            onExportAll={async () => aopFiltered || []}
          />
        </CatalogTableC>
    </>
  );
};

export default ManageFirmPracticeHeadsTab;
